// When the DOM is ready - attach the Tabs Slider to the Window to be able to call from outside
function documentReady(tabsSliderInit) {
  'use strict';

  if (
    document.attachEvent
      ? document.readyState === 'complete'
      : document.readyState !== 'loading'
  ) {
    tabsSliderInit();
  } else {
    document.addEventListener('DOMContentLoaded', tabsSliderInit);
  }
}

// attach the Tabs Slider to the Window
export default function tabsSliderLib() {
  'use strict';

  var consoleMessagePrefix = 'Tabs Slider Log - ';

  var userBrowser = navigator.userAgent || navigator.vendor || window.opera;

  if (typeof window.tabsSlider === 'undefined') {
    window.tabsSlider = tabsSliderInit;
  }

  // returns the instance of Tabs Slider
  function tabsSliderInit(config) {
    var updatedConfig =
      !!config && config.applyDefaultValues
        ? applyDefaultConfig(config)
        : config;

    return isValidConfig(updatedConfig)
      ? new TabsSlider(updatedConfig)
      : console.error(
          consoleMessagePrefix,
          "Please Ensure you're passing the correct config object to init method."
        );
  }

  // Constructor function that creates Tabs Slider instance
  function TabsSlider(config) {
    // data
    this.tabsContainerCssClass = config.tabsContainerCssClass;
    this.tabCssClass = config.tabCssClass;
    this.activeTabCssClass = config.activeTabCssClass;
    this.menuContainerCssClass = config.menuContainerCssClass;
    this.menuCssClass = config.menuCssClass;
    this.activeMenuCssClass = config.activeMenuCssClass;
    this.menuUnderlineCssClass = config.menuUnderlineCssClass;
    this.defaultTabNumber = config.defaultTabNumber;
    this.display = config.display;
    this.callbacks = {
      initialized: () => {},
      tabSelected: () => {},
    };
    this.init = function initTabsSliderInstance() {
      tabsSlider.call(this);
    };
  }

  // fires callback on event
  TabsSlider.prototype.on = function (type, fn) {
    this.callbacks[type]
      ? (this.callbacks[type] = fn)
      : console.warn(consoleMessagePrefix, 'There is no ' + type + ' event');
  };

  // validates the config, passed to the instance
  function isValidConfig(config) {
    return (
      !!config &&
      typeof config.tabsContainerCssClass == 'string' &&
      config.tabsContainerCssClass.length > 0 &&
      typeof config.tabCssClass == 'string' &&
      config.tabCssClass.length > 0 &&
      typeof config.activeTabCssClass == 'string' &&
      config.activeTabCssClass.length > 0 &&
      typeof config.menuContainerCssClass == 'string' &&
      config.menuContainerCssClass.length > 0 &&
      typeof config.menuCssClass == 'string' &&
      config.menuCssClass.length > 0 &&
      typeof config.activeMenuCssClass == 'string' &&
      config.activeMenuCssClass.length > 0 &&
      typeof config.menuUnderlineCssClass == 'string' &&
      config.menuUnderlineCssClass.length > 0 &&
      typeof config.defaultTabNumber == 'number'
    );
  }

  function applyDefaultConfig(config) {
    return Object.assign(getDefaultValues(), config);
  }

  function getDefaultValues() {
    return {
      tabsContainerCssClass: 'tabsSlider--tabsWrapper',
      tabCssClass: 'tabsSlider--tab',
      activeTabCssClass: 'tabsSlider--tab-active',
      menuContainerCssClass: 'tabsSlider--menuWrapper',
      menuCssClass: 'tabsSlider--menu',
      activeMenuCssClass: 'tabsSlider--menu-active',
      menuUnderlineCssClass: 'tabsSlider--menuUnderline',
      defaultTabNumber: 0,
    };
  }

  // Tabs Slider lib
  function tabsSlider() {
    // instance reference
    var instance = this;
    const displayType = instance.display || 'flex';
    // index of selected tab
    var currentIndex = null;
    // the timeout on resize event
    var resizeTimeout = null;
    // tabs
    var tabsContainer = document.getElementsByClassName(
      this.tabsContainerCssClass
    );
    var tabs =
      tabsContainer.length > 0
        ? tabsContainer[0].getElementsByClassName(this.tabCssClass)
        : [];
    // menus
    var menusContainer = document.getElementsByClassName(
      this.menuContainerCssClass
    );

    var menus =
      menusContainer.length > 0
        ? menusContainer[0].getElementsByClassName(this.menuCssClass)
        : [];
    var menuUnderline = document.getElementsByClassName(
      this.menuUnderlineCssClass
    );
    // thresholds
    var thresholdX = null;
    var thresholdY = null;
    var transformMenuContainer;
    var isSwipe = false;
    // var bodyDoc = document.getElementsByTagName('body')[0];
    // if we have the same number of tabs and menus - init
    if (
      menus.length === tabs.length &&
      menus.length !== 0 &&
      tabs.length !== 0
    ) {
      var tabNumber =
        this.defaultTabNumber <= tabs.length && this.defaultTabNumber > -1
          ? this.defaultTabNumber
          : 0;

      // subscribing to resize event
      window.addEventListener('resize', onResizeEvent);

      setupThreshold();

      // init
      initTabs();
      initMenus();
      // default
      selectTab(tabNumber);
      // set timeout to wait all the css rules applied
      setTimeout(function selectMenuWithTimeout() {
        selectMenu(tabNumber);
      }, 100);

      dispatch('initialized');
    } else {
      console.error(
        consoleMessagePrefix,
        'Something went wrong. There are ' +
          menus.length +
          ' menu items and ' +
          tabs.length +
          ' tab containers'
      );
    }

    // run callback on event dispatch
    function dispatch(type, event) {
      instance.callbacks[type] && typeof instance.callbacks[type] == 'function'
        ? instance.callbacks[type](event)
        : console.log(
            consoleMessagePrefix,
            type,
            'event have no callback function'
          );
    }

    function onResizeEvent() {
      // clear the timeout
      clearTimeout(resizeTimeout);
      // start timing for event 'completion'
      resizeTimeout = setTimeout(selectMenuOnResizeEventTimeout, 300);

      function selectMenuOnResizeEventTimeout() {
        setupThreshold();
        Array.prototype.forEach.call(menus, selectMenuOnResizeEvent);
      }

      function selectMenuOnResizeEvent(element, index) {
        if (
          element.classList.contains(instance.activeMenuCssClass) &&
          index !== currentIndex
        ) {
          selectMenu(index);
        }
      }
    }

    /**
     *
     *  Menu functionality
     *
     **/

    function initMenus() {
      // start and move x-axis points
      var touchStartX = 0;
      var touchMoveX = 0;

      menusContainer[0].addEventListener(
        'touchstart',
        onTouchMenuStart,
        passiveSupported ? { passive: true } : false
      );
      menusContainer[0].addEventListener(
        'touchmove',
        onTouchMenuMove,
        passiveSupported ? { passive: true } : false
      );
      menusContainer[0].addEventListener(
        'touchend',
        onTouchMenuEnd,
        passiveSupported ? { passive: true } : false
      );

      Array.prototype.forEach.call(menus, addEventListenersForMenus);

      function onTouchMenuStart(event) {
        // starting with the touched point plus already translateX value
        touchStartX =
          event.changedTouches[0].screenX + getCurrentMenuTransition();
        // reset move value
        touchMoveX = 0;
      }

      function onTouchMenuMove(event) {
        if (menusContainer[0].offsetWidth > window.innerWidth) {
          if (touchStartX !== 0) {
            touchMoveX = event.changedTouches[0].screenX - touchStartX;
            // do not allow to scroll menu outside of screen
            if (touchMoveX > 0) {
              touchMoveX = 0;
            } else if (
              Math.abs(touchMoveX) >
              menusContainer[0].offsetWidth - window.innerWidth
            ) {
              touchMoveX = -(menusContainer[0].offsetWidth - window.innerWidth);
            }
            if (Math.abs(touchMoveX) > transformMenuContainer) {
              touchMoveX *= 1.2;
              touchMoveX = Math.max(
                touchMoveX,
                window.innerWidth - menusContainer[0].offsetWidth
              );
            }

            addMenuAnimationCss(touchMoveX);
          }
        }
      }

      function onTouchMenuEnd() {
        // reset values
        touchStartX = 0;
        touchMoveX = 0;
      }

      function addEventListenersForMenus(element, index) {
        element.addEventListener('click', function onClickEventForMenu() {
          if (index !== currentIndex) {
            selectMenu(index);
            selectTab(index);
          }
        });
      }
    }

    function addMenuAnimationCss(position) {
      if (menusContainer.length > 0)
        menusContainer[0].style.transform = 'translateX(' + position + 'px)';
    }

    function addUnderlineAnimationCss(position) {
      if (menuUnderline.length > 0)
        menuUnderline[0].style.transform = 'translateX(' + position + 'px)';
    }

    function resizeUnderlineCss(index) {
      if (menuUnderline.length > 0)
        menuUnderline[0].style.width = menus[index].offsetWidth + 'px';
    }

    function getCurrentMenuTransition() {
      transformMenuContainer = Number(
        menusContainer[0].style.transform.replace(/[^\d.]/g, '')
      );
      return Number(menusContainer[0].style.transform.replace(/[^\d.]/g, ''));
    }

    function selectMenu(index) {
      // default
      var underlineTranslateX = 0;
      var menuTranslateX = 0;
      let widthToCompare = window.innerWidth;
      if (window.innerWidth < 992) {
        widthToCompare = window.innerWidth;
      } else {
        if (instance.menuCssClass === 'tabsSlider2--menu') {
          widthToCompare = document.getElementsByClassName(
            'extraScreen active'
          )[0]
            ? document.getElementsByClassName('extraScreen active')[0]
                .offsetWidth
            : window.innerWidth;
        }
      }

      // move menu only if menu is longer than window width
      if (menusContainer[0]) {
        if (menusContainer[0].offsetWidth > widthToCompare) {
          // move menu to the start
          if (isMenuStart(index, widthToCompare)) {
            menuTranslateX = 0;
            underlineTranslateX = getUnderlineTranslateXForStart(index);
            // move menu to the end
          } else if (isMenuEnd(index, widthToCompare)) {
            menuTranslateX = -(menusContainer[0].offsetWidth - widthToCompare);
            underlineTranslateX = getUnderlineTranslateXForEnd(index);
            // selected item is in the middle
          } else {
            var totalWidth = getUnderlineTranslateXForMobile(index);
            // start moving the menu only if the item overpass the middle of the screen
            if (totalWidth > widthToCompare / 2) {
              menuTranslateX = -(totalWidth - widthToCompare / 2);
              underlineTranslateX =
                totalWidth - getElementWidth(menus[index]) / 2;
            }
          }
        } else {
          // let elemsUnderline = document.getElementsByClassName(
          //   'tabsSlider2--menuUnderline'
          // );
          // if (elemsUnderline[0] && index === 0) {
          //   for (let i = 0; i < elemsUnderline.length; i++) {
          //     elemsUnderline[i].style.marginLeft = '20px';
          //   }
          // } else if (elemsUnderline[0] && index !== 0) {
          //   for (let i = 0; i < elemsUnderline.length; i++) {
          //     elemsUnderline[i].style.marginLeft = '0px';
          //   }
          // }
          let elems = document.getElementsByClassName(
            'tabsSlider2--menuContainer'
          );
          if (elems[0]) {
            for (let i = 0; i < elems.length; i++) {
              elems[i].style.width = '100%';
            }
          }
          underlineTranslateX = getUnderlineTranslateXForDesktop(index);
          if (index === 0 && instance.menuCssClass === 'tabsSlider2--menu') {
            underlineTranslateX = 20;
          }
        }
      }

      resizeUnderlineCss(index);
      addUnderlineAnimationCss(underlineTranslateX);
      addMenuAnimationCss(menuTranslateX);
    }

    function isMenuStart(index, widthToCompare) {
      var menuStartCount = 0;
      var i = 0;

      for (i; i <= menus.length; i++) {
        if (menus[i]) {
          var elementWidth = getElementWidth(menus[i]);
          if (menuStartCount + elementWidth / 2 < widthToCompare / 2) {
            menuStartCount = menuStartCount + elementWidth;
          } else {
            break;
          }
        }
      }

      return i - 1 >= index;
    }

    function isMenuEnd(index, widthToCompare) {
      var menuStartCount = 0;
      var i = menus.length - 1;

      for (i; i >= 0; i--) {
        var elementWidth = getElementWidth(menus[i]);

        if (menuStartCount + elementWidth / 2 < widthToCompare / 2) {
          menuStartCount = menuStartCount + elementWidth;
        } else {
          break;
        }
      }

      return i + 1 <= index;
    }

    function getUnderlineTranslateXForStart(index) {
      var myStyle = window.getComputedStyle(menus[index]);
      var underlineTranslateX = parseFloat(myStyle.marginLeft);
      var i = index - 1;

      for (i; i >= 0; i--) {
        underlineTranslateX = underlineTranslateX + getElementWidth(menus[i]);
      }

      return underlineTranslateX;
    }

    // divisor - for smaller devices where menu is moving, we need to
    function getUnderlineTranslateXForMobile(index) {
      var totalWidth = 0;
      var i = 0;

      for (i; i <= index; i++) {
        if (i === index) {
          totalWidth = totalWidth + getElementWidth(menus[i]) / 2;
        } else {
          totalWidth = totalWidth + getElementWidth(menus[i]);
        }
      }

      return totalWidth;
    }

    function getUnderlineTranslateXForDesktop(index) {
      var totalWidth = 0;
      var i = 0;

      for (i; i < index; i++) {
        totalWidth = totalWidth + getElementWidth(menus[i]);
      }
      return totalWidth;
    }

    function getUnderlineTranslateXForEnd(index) {
      var underlineTranslateX = getElementPadding(menusContainer[0]);
      var i = index;

      for (i; i < menus.length; i++) {
        underlineTranslateX = underlineTranslateX + getElementWidth(menus[i]);
      }
      underlineTranslateX = menusContainer[0].offsetWidth - underlineTranslateX;

      return underlineTranslateX;
    }

    /**
     *
     *  Tabs functionality
     *
     **/

    function initTabs() {
      Array.prototype.forEach.call(tabs, addEventListenersForTabs);

      function addEventListenersForTabs(element, index) {
        // start, move, end for x-axis and y-axis points
        var touchStartX = null;
        var touchStartY = null;
        var touchMoveX = null;
        var touchMoveY = null;
        var touchEndX = null;
        var touchEndY = null;
        var velocityX = null;
        var velocityY = null;

        element.addEventListener(
          'touchstart',
          onTouchStart,
          passiveSupported ? { passive: true } : false
        );
        element.addEventListener(
          'touchmove',
          onTouchMove,
          passiveSupported ? { passive: true } : false
        );
        element.addEventListener(
          'touchend',
          onTouchEnd,
          passiveSupported ? { passive: true } : false
        );

        function onTouchStart(event) {
          event.stopPropagation();
          touchStartX = event.changedTouches[0].screenX;
          touchStartY = event.changedTouches[0].screenY;
          // let tabs = document.querySelectorAll('.itemBoxes a');
          // if (tabs[0]) {
          //   for (let i = 0; i < tabs.length - 1; i++) {
          //     tabs[i].style.pointerEvents = 'none';
          //   }
          // }

          // reset rest
          touchMoveX = null;
          touchMoveY = null;
          touchEndX = null;
          touchEndY = null;
        }

        function onTouchMove(event) {
          if (!isSwipe) {
            var moveX = event.changedTouches[0].screenX - touchStartX;
            var moveY = event.changedTouches[0].screenY - touchStartY;

            velocityX = moveX - touchMoveX;
            touchMoveX = moveX;

            velocityY = moveY - touchMoveY;
            touchMoveY = moveY;

            // if swipe is horizontal
            if (Math.abs(touchMoveX) >= 5 && Math.abs(touchMoveY) <= 5) {
              // prevent vertical scroll at the time horizontal scroll already started
              if (Math.abs(touchMoveY) > 1) {
                event.preventDefault();
              }
              // if (Math.abs(touchMoveX) >= 15) {
              //   // bodyDoc.style.overflowY = 'hidden';
              // }
              // on user swipe and new tab is in scope of tabs
              if (index <= tabs.length || index > 0) {
                if (
                  (index !== 0 && index !== tabs.length - 1) ||
                  (index === 0 && touchMoveX < 0) ||
                  (index === tabs.length - 1 && touchMoveX > 0)
                ) {
                  addTabAnimationCss(
                    element,
                    ((touchMoveX / window.innerWidth) * 100).toFixed(2),
                    1 - (Math.abs(touchMoveX) / window.innerWidth).toFixed(3)
                  );
                  if (Math.abs(touchMoveX) >= 15) {
                    element.style.touchAction = 'none';
                  }
                }

                if (Math.abs(touchMoveY) <= 100) {
                  if (tabs[index - 1] && touchMoveX > 0) {
                    // animate tab
                    addTabAnimationCss(
                      tabs[index - 1],
                      -(
                        100 -
                        ((touchMoveX / window.innerWidth) * 100).toFixed(2)
                      ),
                      1
                    );
                    // animate underline
                  } else if (tabs[index + 1] && touchMoveX < 0) {
                    // animate tab
                    addTabAnimationCss(
                      tabs[index + 1],
                      100 +
                        Number(
                          ((touchMoveX / window.innerWidth) * 100).toFixed(2)
                        ),
                      1
                    );
                    // animate underline
                  }
                }
              }
            }
          }
        }

        function onTouchEnd(event) {
          if (!isSwipe) {
            touchEndX = event.changedTouches[0].screenX;
            touchEndY = event.changedTouches[0].screenY;

            var x = touchEndX - touchStartX;
            var y = touchEndY - touchStartY;

            // if swiped is horizontal
            if (
              Math.abs(x) > thresholdX &&
              Math.abs(x) >= Math.abs(y) &&
              Math.abs(y) <= (/android/i.test(userBrowser) ? 100 : 20)
            ) {
              startSwipe();
              // swipe left
              if (
                x < 0 &&
                index + 1 < tabs.length &&
                (velocityX < -4 || x < -Math.floor(0.1 * element.offsetWidth))
              ) {
                selectMenu(index + 1);
                selectTab(index + 1);
                // swipe right
              } else if (
                x > 0 &&
                index - 1 >= 0 &&
                (velocityX > 4 || x > Math.floor(0.1 * element.offsetWidth))
              ) {
                selectMenu(index - 1);
                selectTab(index - 1);
                // reset to default
              } else {
                resetOnTouch(element);
              }
              // reset to default
            } else {
              resetOnTouch(element);
            }
            element.style.touchAction = 'unset';
            // bodyDoc.style.overflowY = 'unset';
            // bodyDoc.style.position = 'inherit';
            // tabsContainer[0].style.position = 'relative';

            // reset to default
            touchStartX = null;
            touchMoveX = null;
          }
        }
      }
    }

    function addTabAnimationCss(element, transform, opacity) {
      element.style.opacity = opacity.toString();
      element.style.transform = 'translate3d(' + transform + '%,0,0)';
    }

    function addTabPositionCss(element, display, position) {
      var style = window.getComputedStyle(element);

      // preventing blinking
      // if (display !== style.display) {
      // element.style.display = display;
      // }

      // preventing blinking
      if (position !== style.position) {
        element.style.position = position;
      }
    }

    function resetOnTouch(element) {
      addTabAnimationCss(element, 0, 1);
      if (element.nextElementSibling) {
        addTabAnimationCss(element.nextElementSibling, 100, 1);
      }
      if (element.previousElementSibling) {
        addTabAnimationCss(element.previousElementSibling, -100, 1);
      }
      finishSwipe();
    }

    function selectTab(newIndex) {
      addTabPositionCss(tabs[newIndex], displayType, 'fixed');

      // do nothing if user click on the same element
      if (newIndex !== currentIndex) {
        var updateTabsPositionsPromise = new Promise(updateTabsPositions);

        // using promises to ensure sequence and timeout to apply style changes
        updateTabsPositionsPromise
          .then(updateNewAndCurrentTabsPromise)
          .then(finishTabsStylingPromise)
          .then(tabIsSelected);

        function updateNewAndCurrentTabsPromise() {
          return new Promise(updateNewAndCurrentTabs);
        }

        function finishTabsStylingPromise() {
          return new Promise(finishTabsStyling);
        }

        function tabIsSelected() {
          dispatch('tabSelected', newIndex);
        }
      }

      function updateTabsPositions(resolve) {
        Array.prototype.forEach.call(tabs, styleTab);

        setTimeout(resolve, 50);

        function styleTab(element, index) {
          if (index !== newIndex && index !== currentIndex) {
            addTabPositionCss(element, 'none', 'fixed');
            // send to left
            if (index < newIndex) {
              addTabAnimationCss(element, -100, 1);
              // send to right
            } else {
              addTabAnimationCss(element, 100, 1);
            }
          }
        }
      }

      function updateNewAndCurrentTabs(resolve) {
        if (currentIndex !== null) {
          // move current tab to left
          if (newIndex > currentIndex) {
            addTabAnimationCss(tabs[currentIndex], -100, 0);
            // move current tab to right
          } else {
            addTabAnimationCss(tabs[currentIndex], 100, 0);
          }
        }

        // update current tab
        addTabAnimationCss(tabs[newIndex], 0, 1);

        setTimeout(resolve, 200);
      }

      function finishTabsStyling(resolve) {
        // prepare prev tab - none
        if (tabs[newIndex - 1]) {
          addTabPositionCss(tabs[newIndex - 1], displayType, 'fixed');
        }

        // prepare next tab
        if (tabs[newIndex + 1]) {
          addTabPositionCss(tabs[newIndex + 1], displayType, 'fixed');
        }

        addTabPositionCss(tabs[newIndex], displayType, 'initial');
        if (currentIndex !== null) {
          addTabPositionCss(tabs[currentIndex], displayType, 'fixed');
        }

        // all the styling applied, now the new tab is selected
        currentIndex = newIndex;

        Array.prototype.forEach.call(menus, updateSelectedClassForMenu);
        Array.prototype.forEach.call(tabs, updateSelectedClassForTab);

        function updateSelectedClassForMenu(element, index) {
          if (index === newIndex) {
            element.classList.add(instance.activeMenuCssClass);
          } else {
            element.classList.remove(instance.activeMenuCssClass);
          }
        }

        function updateSelectedClassForTab(element, index) {
          if (index === newIndex) {
            element.classList.add(instance.activeTabCssClass);
          } else {
            element.classList.remove(instance.activeTabCssClass);
          }
        }

        finishSwipe();

        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // new tab should always start from top

        if (/android/i.test(userAgent)) {
          let rootElem = document.getElementById('root');
          if (rootElem) {
            rootElem.scrollTo({ top: 0 });
          }
        }
        window.scroll(0, 0);

        setTimeout(resolve, 0);
      }
    }

    /**
     *
     *  general functionality
     *
     **/

    function startSwipe() {
      isSwipe = true;
    }
    function finishSwipe() {
      isSwipe = false;
    }

    function getElementWidth(element) {
      var style = window.getComputedStyle(element);

      return (
        element.offsetWidth +
        parseFloat(style.marginLeft) +
        parseFloat(style.marginRight) -
        parseFloat(style.paddingLeft) -
        parseFloat(style.paddingRight) +
        parseFloat(style.borderLeftWidth) +
        parseFloat(style.borderRightWidth)
      );
    }

    function getElementPadding(element) {
      var style = window.getComputedStyle(element);

      return parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    }

    function setupThreshold() {
      thresholdX = Math.max(
        4,
        Math.floor(0.02 * (window.innerWidth || document.body.clientWidth))
      );
      thresholdY = Math.max(
        25,
        Math.floor(0.15 * (window.innerHeight || document.body.clientHeight))
      );
    }

    var passiveSupported = false;

    try {
      var options = {
        // This function will be called when the browser attempts to access the passive property.
        get passive() {
          passiveSupported = true;
        },
      };

      window.addEventListener('test', options, options);
      window.removeEventListener('test', options, options);
    } catch (err) {
      passiveSupported = false;
    }
  }
}

documentReady(tabsSliderLib);
